module.exports = __webpack_public_path__ + "img/5-1.85628c14.png";